import { api } from './api';
import type { ProposalInfo } from '@/types/governance';

export const governanceService = {
  /**
   * Fetch all proposals with optional filters
   * @param active - If true, only return proposals in voting period
   * @param status - Filter by specific proposal status (1-5)
   */
  async getProposals(active?: boolean, status?: number): Promise<ProposalInfo[]> {
    const params: Record<string, string | number | boolean> = {};
    if (active !== undefined) {
      params.active = active;
    }
    if (status !== undefined) {
      params.status = status;
    }
    return api.get<ProposalInfo[]>('/proposals', Object.keys(params).length > 0 ? params : undefined);
  },

  /**
   * Fetch a single proposal by ID
   */
  async getProposal(proposalId: number): Promise<ProposalInfo> {
    return api.get<ProposalInfo>(`/proposals/${proposalId}`);
  },

  /**
   * Fetch only active proposals (in voting period)
   */
  async getActiveProposals(): Promise<ProposalInfo[]> {
    return this.getProposals(true);
  },

  /**
   * Fetch passed proposals
   */
  async getPassedProposals(): Promise<ProposalInfo[]> {
    return this.getProposals(undefined, 3); // ProposalStatus.PASSED = 3
  },

  /**
   * Fetch rejected proposals
   */
  async getRejectedProposals(): Promise<ProposalInfo[]> {
    return this.getProposals(undefined, 4); // ProposalStatus.REJECTED = 4
  },
};
